import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import { TpTemplateInfo } from '../../../api/models/assets';
import { TpDataContext } from '../../../data/interfaces';
import { TEMPLATE_QUERY_PARAM } from '../../../data/templateSlice.helpers';
import { addDashboard } from '../data/dashboardsSlice';
import { createDashboardFromTemplate } from '../data/createDashboardFromTemplate';

export function useSelectDashboardTemplate() {
  const dispatch = useAppDispatch();
  const [, setSearchParams] = useSearchParams();

  return useCallback(
    (selectedTemplate: TpTemplateInfo, dataContext: TpDataContext, assetId: string, templateId: string | null) => {
      const newDashboardDef = createDashboardFromTemplate(
        {
          dataContext,
          contextVariables: {},
        },
        selectedTemplate,
        assetId,
      );
      dispatch(addDashboard({ dashboardDef: newDashboardDef }));
      setSearchParams(
        (prevParams) => {
          const nextParams = new URLSearchParams(prevParams);
          if (templateId) {
            nextParams.set(TEMPLATE_QUERY_PARAM, templateId);
          } else {
            nextParams.delete(TEMPLATE_QUERY_PARAM);
          }
          return nextParams;
        },
        { replace: true },
      );
    },
    [dispatch, setSearchParams],
  );
}
